import {IQueryOptions, QueryKey, useQueryWrapper} from "./api-hooks-common";
import {MeasurementDevicesApi} from "../MeasurementDevicesApi";

export const useGetGeoMeasurementsDevices = (options?: IQueryOptions) =>
  useQueryWrapper(
    [QueryKey.GEO_MEASUREMENT_DEVICES],
    () => MeasurementDevicesApi.getGeoMeasurementsDevices(),
    null,
    options
  );

export const useGetMeasurementDevicesReadings = (
  topic: string,
  devicesId: string,
  options?: IQueryOptions
) =>
  useQueryWrapper(
    [QueryKey.MEASUREMENT_DEVICES_READINGS, topic, devicesId],
    () => MeasurementDevicesApi.getMeasurementDevicesReadings(topic, devicesId),
    null,
    options
  );
  
export const useGetMeasurementDevicesByTags = (options?: IQueryOptions) =>
  useQueryWrapper(
    [QueryKey.MEASUREMENT_DEVICES_BY_TAGS],
    () => MeasurementDevicesApi.getMeasurementDevicesByTags(),
    null,
    options
  );